import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  background-color: var(--color-white);

  & > table {
    ${tw`w-full`};

    & > thead {
      ${tw`sticky z-10`};
      top: var(--nav-height);
      background-color: #f0ebe1;
      color: var(--color-gold-black);
    }

    & > thead {
      ${tw`hidden sm:table-header-group`};
    }

    & > thead > tr > th {
      ${tw`text-left py-4 px-4 align-bottom whitespace-nowrap`};
    }

    & > tbody {
      ${tw`divide-y divide-gray-50`};
    }
  }
`

export const BlankSlate = styled.div`
  ${tw`p-8`};
`
